import { PriorityList } from '@/components/PriorityList';
import { usePriority } from '@/features/ManageContacts/hooks/usePriority';
import type { People } from '@/types';

type PriorityType = {
  people: People;
  disablePortal?: boolean;
};

const Priority = ({ disablePortal, people }: PriorityType) => {
  const { changeHandler, priority } = usePriority(people);

  return (
    <PriorityList
      disablePortal={disablePortal}
      value={priority}
      onChange={changeHandler}
    />
  );
};

export { Priority, PriorityList };
